import { Button } from '@progress/kendo-react-buttons';
import { NotificationIndicator } from '../../../../components/notification-indicator';
import { DrawerTabs } from './tabs/tabs';

interface OverlayTabButtonProps {
  icon: string;
  titleIcon: string;
  thisTab: DrawerTabs;
  isDisabled: boolean;
  activeTab: DrawerTabs;
  notificationCount?: number;
  onSetActiveTab: (activeTab: DrawerTabs) => void;
}

export const TabButton = ({
  icon,
  thisTab,
  titleIcon,
  activeTab,
  isDisabled,
  notificationCount = 0,
  onSetActiveTab
}: OverlayTabButtonProps) => {
  return (
    <div className={'position-relative'}>
      <Button
        className={`col align-self-start k-button--tab ${
          activeTab === thisTab ? 'k-button--tab-active' : ''
        } m-0`}
        fillMode={'flat'}
        themeColor={activeTab === thisTab ? 'primary' : 'base'}
        onClick={() => onSetActiveTab(thisTab)}
        disabled={isDisabled}>
        <span className="material-symbols-outlined icon">{icon}</span>
        <span className="label">{titleIcon}</span>
      </Button>
      {notificationCount > 0 && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0
          }}>
          <NotificationIndicator
            counter={notificationCount}
            bgColor={'#FF5527'}
          />
        </div>
      )}
    </div>
  );
};
